import { useAppDetails } from "@/contexts/AppDetailsContext";
import { cn } from "@/lib/utils";
import React, { ReactNode } from "react";

interface AssetBadgeProps {
  symbol?: string;
  timeframe?: string | ReactNode;
  logo?: string;
  size?: number; // optional - defaults to 55
  hideLogo?: boolean;
}

export const AssetBadge: React.FC<AssetBadgeProps> = ({
  symbol,
  timeframe,
  logo,
  size = 45,
  hideLogo = false,
}) => {
  const { details } = useAppDetails();
  return (
    <div className="flex items-center gap-2">
      {!details.isWhiteLabled && !hideLogo && (
        <div
          className="rounded-md overflow-hidden flex justify-center items-center border border-border/10 bg-background/50"
          style={{ width: size, height: size }}
        >
          <img
            src={logo || details?.brokerIcon || "/images/logos/symbol-light.svg"}
            alt={symbol}
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                details?.brokerIcon || "/images/logos/symbol-light.svg";
            }}
            className="w-full h-full object-contain rounded-md"
          />
        </div>
      )}

      <div className="flex flex-col font-bold text-muted-foreground text-base min-w-0">
        {symbol && (
          <p
            className={cn(
              "text-white",
              !timeframe && symbol.length > 10
                ? "whitespace-normal break-all line-clamp-2 leading-tight text-sm max-w-[140px]"
                : "truncate max-w-[185px]"
            )}
            title={symbol}
          >
            {symbol}
          </p>
        )}
        {timeframe && <p className="text-sm">{timeframe}</p>}
      </div>
    </div>
  );
};
